import { useMemo } from 'react';

export const useTooltipClasses = (absolute: boolean = false) => {
  const tooltipClasses = useMemo(() => {
    const positionClass = absolute ? 'ui-absolute' : 'ui-fixed';
    // Canvas inverso: oscuro en tema light y claro en tema dark (`tokens.css` / `themes/dark.css`).
    // Padding spec: base-spacing-xxs / base-spacing-xs → 4px vertical + 8px horizontal (`ui-py-4` / `ui-px-8`).
    return `${positionClass} ui-py-4 ui-px-8 ui-rounded-control-sm ui-max-w-[300px] ui-break-words ui-shadow-lg ui-transition-opacity ui-duration-150 ui-ease-in-out ui-bg-canvas-inverse`;
  }, [absolute]);

  return tooltipClasses;
};
